let initialized = false;

export default function initCommon() {
    if (initialized) return;
    initialized = true;

    const header = document.querySelector('.header-container');
    const footer = document.querySelector('.footer-container');
    if (!header && !footer) return;

    const update = () => {
        if (header) document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
        if (footer) document.documentElement.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
    };

    update();
    if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        if (header) observer.observe(header);
        if (footer) observer.observe(footer);
    } else {
        window.addEventListener('resize', update, { passive: true });
    }
}
